<div [formGroup]="formGroup">
    <mat-form-field appearance="outline" style="width: 100%;"  [ngClass]="isFieldInvalid(fieldKey) ? ['error', 'mat-form-field-invalid', 'ng-invalid'] : ''">
      <mat-label>{{field.label}}</mat-label>
      <input required matInput placeholder="{{field.label}}" [formControlName]="fieldKey">
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%;"  [ngClass]="isFieldInvalid(confirmFieldKey) ? ['error', 'mat-form-field-invalid', 'ng-invalid'] : ''">
      <mat-label>Confirm {{field.label}}</mat-label>
      <input required matInput placeholder="Confirm {{field.label}}" [formControlName]="confirmFieldKey">
    </mat-form-field>
  </div>